// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var MM_provers = require("../mm-utils/MM_provers.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_HashMap = require("rescript/lib/js/belt_HashMap.js");
var Belt_HashSet = require("rescript/lib/js/belt_HashSet.js");
var Belt_HashMapInt = require("rescript/lib/js/belt_HashMapInt.js");
var MM_wrk_ctx_proc = require("./MM_wrk_ctx_proc.bs.js");
var Expln_utils_data = require("@expln/utils/src/main/Expln_utils_data.bs.js");
var MM_proof_tree_dto = require("../mm-utils/MM_proof_tree_dto.bs.js");
var Belt_HashSetString = require("rescript/lib/js/belt_HashSetString.js");
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");

var procName = "MM_wrk_unify";

function bottomUpProverParamsToStr(params) {
  if (params !== undefined) {
    return "{" + ("allowNewDisjForExistingVars=" + (
              params.allowNewDisjForExistingVars ? "true" : "false"
            ) + "") + "}";
  } else {
    return "None";
  }
}

function reqToStr(req) {
  return "Unify(debugLevel=" + String(req.debugLevel) + "" + (", bottomUpProverParams=" + bottomUpProverParamsToStr(req.bottomUpProverParams) + "") + ")";
}

function respToStr(resp) {
  if (resp.TAG === /* OnProgress */0) {
    return "OnProgress(\"" + resp._0 + "\")";
  } else {
    return "Result";
  }
}

function unify(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, rootStmts, bottomUpProverParams, debugLevel, onProgress) {
  return Expln_utils_promise.promise(function (resolve) {
              MM_wrk_ctx_proc.beginWorkerInteractionUsingCtx(settingsVer, settings, preCtxVer, preCtx, varsText, disjText, procName, /* Unify */{
                    rootStmts: rootStmts,
                    bottomUpProverParams: bottomUpProverParams,
                    debugLevel: debugLevel
                  }, (function (resp, param, endWorkerInteraction) {
                      if (resp.TAG === /* OnProgress */0) {
                        return Curry._1(onProgress, resp._0);
                      }
                      Curry._1(endWorkerInteraction, undefined);
                      Curry._1(resolve, resp._0);
                    }), false, undefined);
            });
}

function processOnWorkerSide(req, sendToClient) {
  var rootStmts = req.rootStmts;
  var proofTree = MM_provers.unifyAll(MM_wrk_ctx_proc.getWrkCtxExn(undefined), MM_wrk_ctx_proc.getWrkFrmsExn(undefined), rootStmts, MM_wrk_ctx_proc.getWrkParenCntExn(undefined), req.bottomUpProverParams, req.debugLevel, (function (msg) {
          Curry._1(sendToClient, {
                TAG: /* OnProgress */0,
                _0: msg
              });
        }), undefined);
  Curry._1(sendToClient, {
        TAG: /* Result */1,
        _0: MM_proof_tree_dto.proofTreeToDto(proofTree, rootStmts.map(function (stmt) {
                  return stmt.expr;
                }))
      });
}

function proofTreeDtoToNewStmtsDto(treeDto, exprToProve, ctx, typeToPrefix, rootExprToLabel, reservedLabels) {
  var newVarTypes = Belt_HashMapInt.fromArray(treeDto.newVars.map(function (param) {
            if (param.length !== 2) {
              throw {
                    RE_EXN_ID: "Match_failure",
                    _1: [
                      "MM_wrk_unify.res",
                      347,
                      53
                    ],
                    Error: new Error()
                  };
            }
            var typ = param[0];
            var $$var = param[1];
            return [
                    $$var,
                    typ
                  ];
          }));
  var node = treeDto.nodes.find(function (node) {
        return MM_context.exprEq(node.expr, exprToProve);
      });
  var proofNode;
  if (node !== undefined) {
    proofNode = node;
  } else {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "the proof tree DTO doesn't contain the node to prove."
          },
          Error: new Error()
        };
  }
  return proofNode.parents.map(function (src) {
                  if (typeof src === "number") {
                    return ;
                  }
                  if (src.TAG !== /* Assertion */1) {
                    return ;
                  }
                  var args = src.args;
                  var hasAsrtWithErr = {
                    contents: false
                  };
                  var hasBackRefErr = {
                    contents: false
                  };
                  var res_newVars = [];
                  var res_newVarTypes = [];
                  var res_newDisj = MM_context.disjMake(undefined);
                  var res_newDisjStr = [];
                  var res_stmts = [];
                  var res = {
                    newVars: res_newVars,
                    newVarTypes: res_newVarTypes,
                    newDisj: res_newDisj,
                    newDisjStr: res_newDisjStr,
                    stmts: res_stmts
                  };
                  var exprToLabelArr = Belt_HashMap.toArray(rootExprToLabel);
                  var exprToLabel = Belt_HashMap.fromArray(exprToLabelArr, MM_context.ExprHash);
                  var reservedLabels$1 = Belt_HashSetString.fromArray(reservedLabels);
                  var getOrCreateLabelForExpr = function (expr, prefix, createIfAbsent) {
                    var label = Belt_HashMap.get(exprToLabel, expr);
                    if (label !== undefined) {
                      return label;
                    }
                    var hyp = MM_context.getHypByExpr(ctx, expr);
                    if (hyp !== undefined) {
                      return hyp.label;
                    }
                    if (createIfAbsent) {
                      var newLabel = Caml_array.get(MM_context.generateNewLabels(ctx, prefix, 1, Caml_option.some(reservedLabels$1), true, undefined), 0);
                      Belt_HashMap.set(exprToLabel, expr, newLabel);
                      Belt_HashSetString.add(reservedLabels$1, newLabel);
                      return newLabel;
                    }
                    throw {
                          RE_EXN_ID: MM_parser.MmException,
                          _1: {
                            msg: "Could not find a label for an expr."
                          },
                          Error: new Error()
                        };
                  };
                  var newVarNames = Belt_HashMapInt.make(8);
                  var reservedVarNames = Belt_HashSetString.make(8);
                  var maxCtxVar = MM_context.getNumOfVars(ctx) - 1 | 0;
                  var intToSym = function (i) {
                    if (i <= maxCtxVar) {
                      var sym = MM_context.ctxIntToSym(ctx, i);
                      if (sym !== undefined) {
                        return sym;
                      }
                      throw {
                            RE_EXN_ID: MM_parser.MmException,
                            _1: {
                              msg: "Cannot determine sym for an existing int in srcToNewStmts."
                            },
                            Error: new Error()
                          };
                    }
                    var name = Belt_HashMapInt.get(newVarNames, i);
                    if (name !== undefined) {
                      return name;
                    }
                    throw {
                          RE_EXN_ID: MM_parser.MmException,
                          _1: {
                            msg: "Cannot determine name of a new var in srcToNewStmts."
                          },
                          Error: new Error()
                        };
                  };
                  var getFrame = function (label) {
                    var frame = MM_context.getFrame(ctx, label);
                    if (frame !== undefined) {
                      return frame;
                    }
                    throw {
                          RE_EXN_ID: MM_parser.MmException,
                          _1: {
                            msg: "Cannot get a frame by label '" + label + " in srcToNewStmts.'"
                          },
                          Error: new Error()
                        };
                  };
                  var addExprToResult = function (label, expr, src, isProved) {
                    expr.forEach(function (ei) {
                          if (!(ei > maxCtxVar && !res_newVars.includes(ei))) {
                            return ;
                          }
                          var typ = Belt_HashMapInt.get(newVarTypes, ei);
                          if (typ !== undefined) {
                            res_newVars.push(ei);
                            res_newVarTypes.push(typ);
                            var newVarName = Caml_array.get(MM_context.generateNewVarNames(ctx, [typ], typeToPrefix, Caml_option.some(reservedVarNames), undefined), 0);
                            Belt_HashMapInt.set(newVarNames, ei, newVarName);
                            Belt_HashSetString.add(reservedVarNames, newVarName);
                            getOrCreateLabelForExpr([
                                  typ,
                                  ei
                                ], "v", true);
                            return ;
                          }
                          throw {
                                RE_EXN_ID: MM_parser.MmException,
                                _1: {
                                  msg: "Cannot determine type of a new var in srcToNewStmts."
                                },
                                Error: new Error()
                              };
                        });
                    var exprStr = expr.map(intToSym).join(" ");
                    var jstf;
                    if (src !== undefined && typeof src !== "number") {
                      switch (src.TAG | 0) {
                        case /* Hypothesis */0 :
                            jstf = undefined;
                            break;
                        case /* Assertion */1 :
                            var label$1 = src.label;
                            var args = src.args;
                            var argLabels = [];
                            getFrame(label$1).hyps.forEach(function (hyp, i) {
                                  if (hyp.typ === /* E */1) {
                                    argLabels.push(getOrCreateLabelForExpr(Caml_array.get(treeDto.nodes, Caml_array.get(args, i)).expr, "", false));
                                    return ;
                                  }
                                  
                                });
                            jstf = {
                              args: argLabels,
                              label: label$1
                            };
                            break;
                        case /* AssertionWithErr */2 :
                            hasAsrtWithErr.contents = true;
                            jstf = undefined;
                            break;
                        
                      }
                    } else {
                      jstf = undefined;
                    }
                    res_stmts.push({
                          label: label,
                          expr: expr,
                          exprStr: exprStr,
                          jstf: jstf,
                          isProved: isProved
                        });
                  };
                  var frame = getFrame(src.label);
                  var eArgs = [];
                  frame.hyps.forEach(function (hyp, i) {
                        if (hyp.typ === /* E */1) {
                          eArgs.push(Caml_array.get(treeDto.nodes, Caml_array.get(args, i)));
                          return ;
                        }
                        
                      });
                  var childrenReturnedFor = Belt_HashSet.make(16, MM_context.ExprHash);
                  var savedExprs = Belt_HashSet.make(16, MM_context.ExprHash);
                  eArgs.forEach(function (node) {
                        Expln_utils_data.traverseTree(Belt_HashSet.fromArray([exprToProve], MM_context.ExprHash), node, (function (param, node) {
                                if (Belt_HashSet.has(childrenReturnedFor, node.expr)) {
                                  return ;
                                }
                                Belt_HashSet.add(childrenReturnedFor, node.expr);
                                var match = node.proof;
                                if (match === undefined) {
                                  return ;
                                }
                                if (typeof match === "number") {
                                  return ;
                                }
                                switch (match.TAG | 0) {
                                  case /* Hypothesis */0 :
                                      return ;
                                  case /* Assertion */1 :
                                      var args = match.args;
                                      var children = [];
                                      getFrame(match.label).hyps.forEach(function (hyp, i) {
                                            if (hyp.typ === /* E */1) {
                                              children.push(Caml_array.get(treeDto.nodes, Caml_array.get(args, i)));
                                              return ;
                                            }
                                            
                                          });
                                      return children;
                                  case /* AssertionWithErr */2 :
                                      hasAsrtWithErr.contents = true;
                                      return ;
                                  
                                }
                              }), (function (path, node) {
                                if (hasAsrtWithErr.contents || hasBackRefErr.contents) {
                                  return Caml_option.some(undefined);
                                } else if (Belt_HashSet.has(path, node.expr)) {
                                  hasBackRefErr.contents = true;
                                  return Caml_option.some(undefined);
                                } else {
                                  Belt_HashSet.add(path, node.expr);
                                  return ;
                                }
                              }), undefined, (function (path, node) {
                                Belt_HashSet.remove(path, node.expr);
                                if (hasAsrtWithErr.contents || hasBackRefErr.contents) {
                                  return Caml_option.some(undefined);
                                }
                                if (Belt_HashSet.has(savedExprs, node.expr)) {
                                  return ;
                                }
                                Belt_HashSet.add(savedExprs, node.expr);
                                var match = node.proof;
                                if (match !== undefined) {
                                  if (typeof match === "number") {
                                    return ;
                                  }
                                  switch (match.TAG | 0) {
                                    case /* Hypothesis */0 :
                                        return ;
                                    case /* Assertion */1 :
                                        addExprToResult(getOrCreateLabelForExpr(node.expr, "", true), node.expr, node.proof, true);
                                        return ;
                                    case /* AssertionWithErr */2 :
                                        hasAsrtWithErr.contents = true;
                                        return Caml_option.some(undefined);
                                    
                                  }
                                } else {
                                  addExprToResult(getOrCreateLabelForExpr(node.expr, "", true), node.expr, undefined, false);
                                  return ;
                                }
                              }), undefined);
                      });
                  if (hasAsrtWithErr.contents || hasBackRefErr.contents) {
                    return ;
                  }
                  addExprToResult(getOrCreateLabelForExpr(exprToProve, "", false), exprToProve, src, args.every(function (idx) {
                            return Belt_Option.isSome(Caml_array.get(treeDto.nodes, idx).proof);
                          }));
                  var varIsUsed = function (v) {
                    if (v <= maxCtxVar) {
                      return true;
                    } else {
                      return res_newVars.includes(v);
                    }
                  };
                  MM_context.disjForEach(treeDto.disj, (function (n, m) {
                          if (varIsUsed(n) && varIsUsed(m) && !MM_context.isDisj(ctx, n, m)) {
                            return MM_context.disjAddPair(res_newDisj, n, m);
                          }
                          
                        }));
                  MM_context.disjForEachArr(res_newDisj, (function (disjArr) {
                          res_newDisjStr.push("$d " + disjArr.map(intToSym).join(" ") + " $.");
                        }));
                  return res;
                }).filter(Belt_Option.isSome).map(Belt_Option.getExn);
}

exports.procName = procName;
exports.unify = unify;
exports.processOnWorkerSide = processOnWorkerSide;
exports.proofTreeDtoToNewStmtsDto = proofTreeDtoToNewStmtsDto;
exports.reqToStr = reqToStr;
exports.respToStr = respToStr;
/* MM_context Not a pure module */
